export default __webpack_public_path__ + "static/adriana-martinez-1-110441f0ab5c54740c84d1547fb01a1b.webp";